import React, { useContext } from "react";
import styles from "./BookDemo.module.scss";
import AppContext from "../../../context/AppContext";
function BookDemo() {
  const { contactForm, setContactForm }: any = useContext(AppContext);

  return (
    <div className={styles["book-demo-wrapper"]}>
      <h3>Transform Customer Feedback into Business Success</h3>
      <p>
        Ready to harness the power of customer reviews to drive your business
        forward?
      </p>
      <button onClick={() => setContactForm(true)}>BOOK DEMO</button>
    </div>
  );
}

export default BookDemo;
